// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","396":"8b9c8457","455":"613fd633","482":"7383cbec","977":"1ff7fdd1"}[chunkId] + ".chunk.js";
};